import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceService } from 'src/app/services/devices/device.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ModalHolidayCalendarComponent } from 'src/app/components/ui/modal-holiday-calendar/modal-holiday-calendar.component';


@Component({
    selector: 'app-anc-holiday',
    imports: [CommonModule, FormsModule, TranslateModule],
    templateUrl: './anc-holiday.component.html',
    styleUrl: './anc-holiday.component.scss'
})
export class AncHolidayComponent implements OnInit {

  @Input()
  allSettings = false;
  device : string = '';
  holidayData:  any[] = [];
  holidayEnable: boolean = false;
  originalData: any[] = [];

  // selectedPeriodIndex = 0;


  constructor(private _aRoute: ActivatedRoute, private _deviceService: DeviceService, private _modalService: ModalService) { }


  ngOnInit(): void {
    this._aRoute.parent?.parent?.params
      .subscribe((params: Params) => this.device = params['serial']);

    this._deviceService.getModuleInfo(this.device, "holiday").subscribe(data=>{
      const dataParsed = this.parseHolidayPeriodsArray(data);
      this.formatHoliladayDate(dataParsed);
      this.holidayEnable = data.cfg.enable;
      console.log('Holiday enabled  ',this.holidayEnable);

      console.log('Holiday Data final:  ', this.originalData);
    })

  }

  //  Cada periodo usa 10 bytes útiles con la siguiente estructura:
  //   - [0] iday (1..31)      - Día inicio
  //   - [1] imon (1..12)      - Mes inicio
  //   - [2] ihou (0..23)      - Hora inicio
  //   - [3] imin (0..59)      - Minuto inicio
  //   - [4] fday (1..31)      - Día fin
  //   - [5] fmon (1..12)      - Mes fin
  //   - [6] fhou (0..23)      - Hora fin
  //   - [7] fmin (0..59)      - Minuto fin
  //   - [8] autoreload (0/1)  - Auto-recarga
  //   - [9] enabled (0/1)     - Periodo activo
  formatHoliladayDate(dataParsed?: any[]) {
    this.holidayData = [];
    this.originalData = [];


    if (!dataParsed || dataParsed.length === 0) {
      return;
    }
    console.log('dataParsedLenght', dataParsed.length);
    dataParsed.forEach((period, i) => {
      const periodIndex = i+1;
      const starDay = period.data[0]
      const starMonth = period.data[1]
      const starHour = period.data[2]
      const starMinute = period.data[3]

      const endDay = period.data[4]
      const endMonth = period.data[5]
      const endHour = period.data[6]
      const endMinute = period.data[7]

      const autoreload = period.data[8]
      const enabled = period.data[9]

      const formatted = {
        period: periodIndex,
        startDay : starDay, startMonth : starMonth, startHour : this.formatTime(starHour, starMinute),
        endDay : endDay, endMonth : endMonth, endHour : this.formatTime(endHour, endMinute),
        autoreload : autoreload, enabled : enabled
      };

      this.originalData.push(formatted);

      // Si no está enabled, no debe aparecer en la UI
      // if (Number(enabled) === 1) {
        this.holidayData.push(formatted);
      // }
    })
  }


  parseHolidayPeriodsArray(source: any): any[] {
    const cfg = source?.cfg;
    const result: any[] = [];

  for (let i = 1; i <= 4; i++) {
    result.push({
      key: `period${i}`,
      data: JSON.parse(cfg[`period${i}`])
    });
  }

  return result;
}

  formatTime(hour: number, minute: number): string {
    return ('0' + hour).slice(-2) + ':' + ('0' + minute).slice(-2);
  }

  // selectPeriod(index: number): void {
  //   this.selectedPeriodIndex = index;
  // }

  addPeriod(): void {
    this.holidayEnable = true;
    console.log('holidaydata.length ',this.holidayData.length);
    if (this.holidayData.length >= 4) {
      return; // No se pueden añadir más de 4 periodos
    }

    // Añadir un nuevo periodo con valores por defecto
    this.holidayData.push({
      startDay: 1,
      startMonth: 1,
      startHour: '00:00',
      endDay: 1,
      endMonth: 1,
      endHour: '00:00',
      autoreload: 0,
      enabled: 1
    });
    this.openCalendarModal(this.holidayData.length - 1);

  }

  deletePeriod(index: number): void {
    this.holidayData[index].enabled = 0;
    this.holidayData.splice(index, 1);
  }

  openCalendarModal(editSelectedIndex?: number): void {

    const modalRef = this._modalService.open(ModalHolidayCalendarComponent, {
      centered: true,
      scrollable: true,
      size: 'xl',
      windowClass: 'scheduler-window' // clase que usarás en el CSS
    });
    modalRef.componentInstance.holidayData = this.holidayData;
    if (editSelectedIndex !== undefined) {
      modalRef.componentInstance.selectedIndex = editSelectedIndex;
    }

  }

}
